/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_LEAD',
  'LOAD_LEADS',
  'INVITE_LEADS',
]);



// WEBPACK FOOTER //
// ./src/constants/LeadConstants.js